/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { CalendarFeedFilterComponent } from "cms/shared/feeds/calendar/calendar-feed-as-component";

const FeedComponentCalendar = (props) => {

    const component = props?.component;
    const selected_type = component?.selected_type;
    const selected_category = component?.selected_category;
    const enable_bar = component?.enable_bar;

    return (
        <>
            <CalendarFeedFilterComponent
                selected_type={selected_type}
                selected_category={selected_category}
                enable_bar={enable_bar}
            />
        </>
    );
};

FeedComponentCalendar.displayName = "FeedComponentCalendar";
export { FeedComponentCalendar };
